const files = require.context('.', true, /\.(vue|js)$/);
export let modules = {};
files.keys().forEach(key => {
  let m = files(key).default;
  if (m) {
    let k = key.substring(key.lastIndexOf("/") + 1, key.lastIndexOf("."));
    modules[k] = m;
  }
});
export default modules;